<template>
  <v-container>
    <v-row justify="center" align="center">
      <v-col sm="12" md="10">
        <v-layout justify-center align-start class="printNone">
          <v-flex xs12>
            <div class="title pa-3 primary--text font-weight-bold">{{ $t('council_license_application') | uppercase }}</div>
          </v-flex>
          <v-layout align-center reverse row wrap class="printNone">
            <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" @click="print(data, 1)">{{ $t('page_license.print') }}</v-btn>
          </v-layout>
        </v-layout>
        <v-layout justify-center align-start class="printNone pa-2" style="">
          <v-flex xs12 style="background-color: dodgerblue" class="pa-2">
            <div class="pa-1 pt-2 pb-2 white--text body2">{{ $t('council_license_message') | uppercase }}</div>
            <div class="pa-1 white--text body2">{{ $t('council_license_message2') | uppercase }}</div>
            <div class="pa-1 white--text body2">{{ $t('council_license_message3') | uppercase }}</div>
          </v-flex>
        </v-layout>
        <v-layout justify-center align-start v-if="Object.keys(data).length === 0" class="printNone">
          <v-flex xl2 md4 sm6 xs12>
            <v-card class="br-10 pa-4 text-center">
              <div class="title pa-3">{{ $t('no_account_selected') }}</div>
              <v-layout row wrap pt-2 justify-center>
                <v-btn :block="$vuetify.breakpoint.xsOnly" color="primary" class="white--text" rounded type="button" large @click="$router.push('/'); resetData()">{{ $t('go_to_homepage') }}</v-btn>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-row>
          <v-col cols="12">
            <v-list two-line dense>
              <v-subheader class="printNone"><h3>{{ $t('application_information') }}</h3></v-subheader>
              <v-divider class="printNone"/>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data._id }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('reference_no') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.timestamp | date }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('application_date') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="text-h6 text-uppercase font-weight-bold">{{ $t(data.status) | uppercase }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('status') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ (data.status_update_date || data.timestamp) | date }}</v-list-item-title>
                  <v-list-item-subtitle class="body-2">{{ $t('last_status_update') }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
        <br />
        <v-list two-line dense>
          <v-subheader class="printNone"><h3>{{ $t('applicant_information') }}</h3></v-subheader>
          <v-divider class="printNone"/>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.name }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('name', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ $t(data.applicant.identity_type) }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('identity_type', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.identity_no }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('identity_no', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.mobile_tel }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('phone', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 font-weight-bold">{{ data.applicant.email }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('email', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.applicant.address }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('address', { field: $t("applicant") }) }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <br />
        <v-list two-line class="d-print-flex">
          <v-subheader class="printNone pb-2" style="background-color: white;"><h3>{{ $t('business_information') }}</h3></v-subheader>
          <v-divider class="printNone" style=" margin-top: -5px"/>
          <v-list-item v-if="data.application">
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.application.trading_no }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('trading_no') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-list-item v-if="data.category">
            <v-list-item-content>
              <v-list-item-title class="body-2 text-uppercase font-weight-bold">{{ data.category.businesstype }}</v-list-item-title>
              <v-list-item-subtitle class="body-2">{{ $t('business_category') }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import vuex from 'vuex'
import QrcodeVue from 'qrcode.vue'

export default {
  async created () {
    await this.fetchData({ id: this.$route.params.id, type: this.$route.query.type })
    console.log(this.data)
    if (!this.data._id || this.data._id.length === 0) {
      this.$router.go(-1)
    }
  },
  components: {
    QrcodeVue
  },
  computed: {
    ...vuex.mapState({
      data: state => state.licenseForm.data,
      username: state => state.auth.username
    })
  },
  data () {
    return {
      url: 'http://services.mptpay.net/' + window.location.hash
    }
  },
  methods: {
    ...vuex.mapActions({
      fetchData: 'licenseForm/fetchData'
    }),
    hideIC: function (text) {
      var t = text
      var hiddenText = ''
      if (t.length !== 0) {
        for (var i = 0; i < t.length; i++) {
          if (i < t.length - 4) {
            hiddenText += '*'
          } else {
            hiddenText += t[i]
          }
        }
      }
      return hiddenText
    },
    hideText (text) {
      var t = text
      var hiddenText = ''
      for (var i = 0; i < t.length; i++) {
        if (i > 4) {
          hiddenText += '*'
        } else {
          hiddenText += t[i]
        }
      }
      return hiddenText
    },
    print: async function (data, type) {
      this.loading = true
      function pad (n) { return n < 10 ? '0' + n : n }
      const logo = await this.$store.dispatch('metadata/fetchLogoBase64', { council: 'mpt' })
      const ref = this.data._id
      const params = {
        date: pad(new Date(this.data.timestamp).getDate()) + '/' + pad(new Date(this.data.timestamp).getMonth() + 1) + '/' + new Date(this.data.timestamp).getFullYear(),
        logo: logo,
        record: data,
        route: window.location.href,
        title: 'PERMOHONAN LESEN OPERASI'
      }
      const fileName = 'PERMOHONANLESENPERNIAGAAN_' + ref + '.pdf'
      let printWorker = new Worker('print/receipt/license_operation.js')
      printWorker.onmessage = function (response) {
        if (!window.hasOwnProperty('cordova')) {
          const anchor = document.createElement('a')
          anchor.href = URL.createObjectURL(response.data)
          anchor.download = fileName
          document.body.appendChild(anchor)
          anchor.click()
          anchor.remove()
          return
        }
        const storageLocation = cordova.file.externalApplicationStorageDirectory
        var errorCallback = function (e) {
          console.error(e)
        }
        window.resolveLocalFileSystemURL(storageLocation,
          function (directory) {
            directory.getFile(fileName, {
              create: true,
              exclusive: false
            },
            function (fileEntry) {
              fileEntry.createWriter(function (writer) {
                writer.onwriteend = function () {
                  cordova.plugins.fileOpener2.open(
                    storageLocation + fileName,
                    'application/pdf',
                    {
                      error: function (e) {
                        console.error('Error status: ' + e.status + ' - Error message: ' + e.message)
                      },
                      success: function () {
                        console.info('file opened successfully')
                      }
                    }
                  )
                }
                writer.seek(0)
                writer.write(response.data)
              }, errorCallback)
            }, errorCallback)
          }, errorCallback)
      }
      printWorker.postMessage(params)
    }
  }
}
</script>

<style>
.br-10 {
  border-radius: 10px;
}

.text-uppercase {
  text-transform: 'uppercase';
  font-weight: 'bold';
}

#councilInfo,
.printShow {
  display: none;
}

@media print {
  nav {
    display: none;
  }
  #councilInfo,
  #councilInfo span {
    display: block;
    text-align: center;
  }
  #printLayout {
    margin-top: -110px;
  }
  .property_info {
    max-width: 400px;
  }
  .display-flex {
    display: flex;
  }
  .printShow {
    display: block;
  }
  .printNone {
    display: none;
  }
  .pageBreak {
    page-break-after: always;
  }
  .width25 {
    width: 25% !important;
  }
  .width33 {
    width: 33% !important;
  }
  .width50 {
    width: 50% !important;
  }
  .marginBottom40 {
    margin-bottom: -40px;
  }
}
</style>
